import React, { Component, Fragment } from 'react';
import MyAccountSideBar from './my-account-side-bar';
import { Route, Router } from 'react-router-dom';
import Profile from './profile';
import Password from './password';
import NewsLetterPreferences from './newsletter-preferences';
import OrdersAndInvoices from './orders-and-invoices';
import ISDA_Library from './isda-library';
import { createBrowserHistory } from 'history';
import SubscriptionsAndDues from './subscriptions-and-dues';
import Bookmarks from './bookmarks';

const history = createBrowserHistory();

class MyAccount extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			ready         : false,
			showFilters   : false,
			isMobile      : false,
			currentSection: this.getCurrentSection()
		};
		this.AccountContent = this.AccountContent.bind( this );
	}

	toggleFilters() {
		this.setState( ( prevState ) => {
			const newShowFilters = !prevState.showFilters;

			// Toggle body scroll based on the state
			if ( newShowFilters ) {
				document.body.classList.add( 'no-scroll' );
			} else {
				document.body.classList.remove( 'no-scroll' );
			}

			return { showFilters: newShowFilters };
		} );
	}

	getCurrentSection() {
		const searchParams = new URLSearchParams( window.location.search );
		return searchParams.get( 'section' ) || '';
	}

	componentDidMount() {
		this.handleResize();
		window.addEventListener( 'resize', this.handleResize.bind( this ) );
		this.unlisten = history.listen( () => {
			this.setState( { currentSection: this.getCurrentSection() } );
		} );
	}

	componentWillUnmount() {
		window.removeEventListener( 'resize', this.handleResize.bind( this ) );
		this.unlisten();
	}

	handleResize() {
		//IF UPDATING SIZE HERE, UPDATE IN _CATEGORY-ARCHIVE.SCSS AS WELL.
		const isMobile = window.innerWidth <= 992;

		if ( !isMobile && this.state.showFilters ) {
			this.setState( { showFilters: false } );
			document.body.classList.remove( 'no-scroll' );
		} else {
			this.setState( { isMobile } );
		}
	}

	getSectionName() {
		switch ( this.state.currentSection ) {
			case 'profile':
				return 'My Profile';
			case 'password':
				return 'Change Password';
			case 'email-preferences':
				return 'Email Preferences';
			case 'orders-and-invoices':
				return 'Orders & Invoices';
			case 'isda-library':
				return 'ISDA Library';
			case 'bookmarks':
				return 'Bookmarks';
			case 'subscriptions-and-dues':
				return 'Subscriptions & Dues';
			case 'delete-account':
				return 'Delete Account';
			default:
				return (!this.state.isMobile ? 'My Profile' : ''
				);
		}
	}

	AccountContent() {
		const { currentSection } = this.state;
		const searchParams = new URLSearchParams( window.location.search );
		const section = searchParams.get( 'section' );

		switch ( section ) {
			case 'profile':
				return <Profile/>;
			case 'password':
				return <Password/>;
			case 'email-preferences':
				return <NewsLetterPreferences/>;
			case 'orders-and-invoices':
				return <OrdersAndInvoices/>;
			case 'isda-library':
				return <ISDA_Library/>;
			case 'bookmarks':
				return <Bookmarks/>;
			case 'delete-account':
				return <DeleteAccount/>;
			case 'subscriptions-and-dues':
				return <SubscriptionsAndDues/>;
			default:
				return (!this.state.isMobile ? <Profile/> : ''
				); // Default to Profile if no section specified
		}
	};

	getBackToAccountButton() {
		if ( this.state.currentSection !== '' && this.state.isMobile ) {
			return (<div className="back-to-account-container">
					<button className="back-to-account-button"
					        onClick={ () => this.setState( { currentSection: '' } ) }>
						<i className="fa fa-arrow-left"></i>
						Back to my account
					</button>
				</div>
			);
		} else {
			return null;
		}
	}

	render() {
		return (<Router history={ history }>
				<div>
					<div class="blue-hero-side-bar-default">
						{ this.state.isMobile && this.state.currentSection === '' &&
						  <MyAccountSideBar isMobile={ true }/> }
						<div class="container">
							<div
								class="decoy-side-bar side-bar-container"></div>
							{ !this.state.isMobile && <MyAccountSideBar
								section={ this.state.currentSection }/> }
							<div class="col-lg-9 main-content">
								{ this.getBackToAccountButton() }
								<div>
									<div class="blue-hero-title-wrap large">

										<h2 class="blue-hero-title align-center">
											<span>{ this.getSectionName() }</span>
										</h2>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="site-content container">
						<div class="decoy-side-bar"></div>
						<div class="col-lg-3 bookstore-sidebar">
						</div>
						<div className="col-lg-9 main-content">
							<switch>
								<Route exact path="/my-account/"
								       render={ () => this.AccountContent() }/>
								{/* <Route path="/my-account/password" component={AccountContent} /> */ }
								{/*<Route path="/my-account/email-preferences" component={EmailPreferences} />
								 <Route path="/my-account/order-history" component={OrderHistory} />
								 <Route path="/my-account/online-library" component={OnlineLibrary} />
								 <Route path="/my-account/bookmarks" component={Bookmarks} />
								 <Route path="/my-account/delete-account" component={DeleteAccount} /> */ }
							</switch>

						</div>
					</div>
				</div>
			</Router>
		);
	}
}

export default MyAccount; // Wrap with withRouter
